e4.cart = {
  storageKeyInternalBackLink: 'e4.cart.internalBackLink',
  cartData: {},
  init: function() {
    if ( jQuery( '.js-e-cart-form' ).length === 1 ) {
      e4.require.js( e4.settings.require.handlebars, function() {
        e4.handlebars.registerHelpers( 'compare hasRelatedProductOrderline getRelatedProductOrderlineId getDesignOrderLineGroupProductCount' );
        e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-cart-orderlines #js-e-handlebars-tmpl-order-summary' );
        // ATTENTION: Please note that all product-add/remove events are trigger on jQuery( document ) and not
        // the cart element.
        e4.cart.event = e4.util.registerEvents(
            'load loaded update updated productadd productadded productremove productremoved orderlinedelete orderlinedeleted orderlineincrease orderlinedecrease',
            'cart' );
        e4.cart.saveInternalBackLink();
        e4.cart.bindEvents();
        e4.cart.orderline.bindEvents();
        e4.cart.load();
      } );
    } else if ( jQuery( '.js-e-cart-quantity' ).length > 0 ) {
      e4.cart.event = e4.util.registerEvents( 'productadd productadded productremove productremoved', 'cart' );
      //e4.cart.updateQuantityInfo();
      e4.cart.msg.init();
    }
  },
  disableActions: function( jsonData ) {
    if ( jsonData.cart.orderlines.length === 0 ) {
      jQuery( '.js-e-checkout-btn' ).addClass( 'disabled' );
      jQuery( '.js-identity-clear-cart' ).hide();
    } else {
      jQuery( '.js-e-checkout-btn' ).removeClass( 'disabled' );
      jQuery( '.js-identity-clear-cart' ).show();
    }
  },
  saveInternalBackLink: function() {
    if ( document.referrer.indexOf( location.protocol + '//' + location.host ) === 0 && document.referrer.indexOf( '/shop/cart/checkout' ) === -1 ) {
      sessionStorage.setItem( e4.cart.storageKeyInternalBackLink, document.referrer );
    }
  },
  goToInternalBackLink: function( event ) {
    var strInternalBackLink = sessionStorage.getItem( e4.cart.storageKeyInternalBackLink );
    if ( strInternalBackLink !== null && strInternalBackLink.indexOf( location.protocol + '//' + location.host ) === 0 ) {
      event.preventDefault();
      location.href = strInternalBackLink;
    }
  },
  bindEvents: function() {
    jQuery( document ).on( 'click', '.js-e-cart-back-link', e4.cart.goToInternalBackLink ).find( '.js-e-cart-form' ).on( 'submit', function( event ) {
      event.preventDefault();
    } );
    jQuery( '.js-e-cart' ).on( 'click', '.js-identity-clear-cart', function( event ) {
      event.preventDefault();
      e4.cart.removeAll();
    } );
    jQuery( document ).on( 'submit', '.js-productdesigner-send-cart-mail-form', ( event ) => {
      event.preventDefault();
      const submitBtn = event.target.querySelector( 'button[type="submit"]' );
      const formData = new FormData( event.target );

      const params = new URLSearchParams();
      for ( const [key, value] of formData.entries() ) {
        params.append( key, value );
      }

      submitBtn.disabled = true;

      const fullName = formData.get('ProductDesignsName');
      const nameParts = fullName.trim().split(' ');
      const firstName = nameParts[0];
      const lastName = nameParts.slice(1).join(' ');
      
      identity.activeCampaign.designerCartSendMail({
        email: formData.get('ProductDesignsEmail'),
        firstName: firstName,
        lastName: lastName,
      });

      const request = fetch( `${ event.target.action }?${ params }` );
      request.then( resp => resp.json() ).then( () => {

        const feedbackText = event.target.querySelector( '.js-productdesigner-send-cart-mail-feedback' );

        feedbackText.classList.remove( 'd-none' );
        submitBtn.innerHTML = `${ submitBtn.textContent } <i class="material-icons ml-1">check</i>`;
      } );
    } );
    jQuery( window ).on( 'resize', e4.cart.setFeeClipPath );
  },
  ajax: function( objAjaxSettings, fnCallback ) {
    var jCart = jQuery( '.js-e-cart' );
    const orderContext = jCart.data( 'context' );

    let url = e4.settings.ecom.cart.url;

    if ( orderContext ) {
      url = `${ e4.settings.ecom.cart.url }?OrderContext=${ orderContext }`;
    }

    var jqXHR = jQuery.ajax( jQuery.extend( {
      url: url,
      method: 'POST',
      dataType: 'json',
      cache: false,
      beforeSend: function() {
        if ( jCart.length === 1 ) {
          jQuery( '.js-e-cart-main, .js-e-cart-aside' ).find( '.js-e-loading-overlay' ).addClass( 'is-loading' );
        }
      },
    }, objAjaxSettings ) );
    jqXHR.done( function( data ) {
      if ( typeof fnCallback === 'function' ) {
        e4.cart.cartData = data;
        fnCallback( data );
      }
      if ( jCart.length === 1 ) {
        jQuery( '.js-e-cart-main, .js-e-cart-aside' ).find( '.js-e-loading-overlay' ).removeClass( 'is-loading' );
      }
    } );
  },
  load: function() {
    var jCart = jQuery( '.js-e-cart' );
    jCart.trigger( e4.cart.event.load );
    e4.cart.ajax( {
      method: 'GET',
    }, function( jsonData ) {
      e4.cart.updateContent( jsonData );

      e4.loading.resolveWait( '.js-e-cart-main' );
      e4.loading.resolveWait( '.js-e-cart-aside' );
      jCart.trigger( e4.cart.event.loaded );
    } );
  },
  removeAll: function() {
    var strBacklink = sessionStorage.getItem( 'e4.cart.internalBackLink' );
    var jCart = jQuery( '.js-e-cart' );
    const orderContext = jCart.data( 'context' );

    let url = location.href;

    if ( orderContext ) {
      url = `${ location.href }?OrderContext=${ orderContext }`;
    }

    jQuery.ajax( {
      url: url,
      method: 'GET',
      beforeSend: function() {
        jQuery( '.js-e-cart-main, .js-e-cart-aside' ).find( '.js-e-loading-overlay' ).addClass( 'is-loading' );
      },
      data: {
        CartCmd: 'emptyCart',
        Redirect: false,
      },
    } ).done( function() {
      if ( strBacklink !== null && strBacklink !== '' ) {
        location.href = strBacklink;
      } else {
        location.reload();
      }

    } );
  },
  addProduct: function( objProductFormData, fnCallback ) {
    var jDocument = jQuery( document ),
        jCart = jDocument.find( '.js-e-cart' ),
        jForm = jQuery( objProductFormData.ref ) || null;
    var objProductData = {
      CartCmd: 'add',
      ProductID: '',
      VariantID: '',
      Quantity: 1,
      Redirect: false,
    };
    if ( jForm !== null ) {
      jForm.find( '[type="submit"]' ).addClass( 'adding-to-cart' );
      delete objProductFormData.ref;
    }

    if ( jQuery.isPlainObject( objProductFormData ) ) {
      jQuery.extend( objProductData, objProductFormData );
    } else if ( jQuery.type( objProductFormData ) === 'string' ) {
      objProductData.ProductID = objProductFormData;
    }
    jDocument.trigger( e4.cart.event.productadd, objProductData );
    e4.cart.ajax( {
      data: objProductData,
    }, function( jsonData ) {
      if ( jCart.length === 1 ) {
        e4.cart.updateContent( jsonData );
        if ( jQuery.isArray( jsonData.cart.lastAdded ) === true ) {
          var objProductLastAdded = jsonData.cart.lastAdded[jsonData.cart.lastAdded.length - 1],
              strOrderlineId = e4.cart.orderline.getIdByProduct( objProductLastAdded );
          e4.cart.orderline.setFocus( strOrderlineId );
        }

      }
      e4.cart.updateQuantityInfo( jsonData.cart );
      if ( typeof fnCallback === 'function' ) {
        fnCallback( jsonData );
      }
      if ( jForm !== null ) {
        jForm.find( '[type="submit"]' ).removeClass( 'adding-to-cart' );
      }
      jDocument.trigger( e4.cart.event.productadded, jsonData );
    } );
  },
  removeProduct: function() {
  },
  currentValueCalculated: 0,
  setFeeClipPath: () => {
    const feeElement = document.querySelector( '.js-free-shipping-bar--mask' );
    if ( feeElement !== null ) {
      const feeElementWidth = feeElement.offsetWidth;
      const progressInPixel = ((e4.cart.currentValueCalculated / 100) * (feeElementWidth));
      document.documentElement.style.setProperty( '--feeShippingProgress', `${ progressInPixel }px` );
    }
  },
  updateContent: function( jsonData ) {
    var jCart = jQuery( '.js-e-cart' );
    jCart.trigger( e4.cart.event.update );
    jCart.find( '.js-e-cart-orderlines' ).html( e4.handlebars.tmpl.cartOrderlines( jsonData ) );
    jCart.find( '.js-e-order-summary' ).html( e4.handlebars.tmpl.orderSummary( jsonData ) );
    e4.cart.updateQuantityInfo( jsonData.cart );
    jCart.trigger( e4.cart.event.updated, jsonData );
    jQuery( '[data-toggle="tooltip"]' ).tooltip();
    e4.cart.disableActions( jsonData );
    if ( document.getElementById( 'free-shipping-bar' ) !== null ) {
      document.documentElement.style.setProperty( '--shippingLabelLeft', `${ jsonData.cart.feeShippingLimit.shippingLimitCalculated }%` );
      document.documentElement.style.setProperty( '--feeLabelLeft', `${ jsonData.cart.feeShippingLimit.feeLimitCalculated }%` );
      e4.cart.currentValueCalculated = jsonData.cart.feeShippingLimit.currentValueCalculated;
      e4.cart.setFeeClipPath();
    }

  },
  updateQuantityInfo: function( objCart = null ) {
    var jCart = jQuery( '.js-e-cart' ),
        jCartQuantity = jQuery( '.js-e-cart-quantity' ),
        jCartCount = jQuery( '.js-e-cart-count' );
    if ( jCartQuantity.length > 0 && jCart.length === 0 ) {
      if ( objCart === null ) {
        e4.cart.ajax( {
          method: 'GET',
        }, function( jsonData ) {
          if ( jQuery.isNumeric( jsonData.cart.productQuantity ) === true ) {
            e4.cart.updateQuantityInfo( jsonData.cart );
          }
        } );
      } else if ( objCart.productQuantity === 0 ) {
        jCartQuantity.empty();
      } else {
        jCartQuantity.html( objCart.productQuantity );
      }
    }
    if ( jCartCount.length > 0 ) {
      if ( objCart === null ) {
        e4.cart.ajax( {
          method: 'GET',
        }, function( jsonData ) {
          if ( jQuery.isNumeric( jsonData.cart.productLinesCount ) === true ) {
            e4.cart.updateQuantityInfo( jsonData.cart );
          }
        } );
      } else if ( objCart.productLinesCount === 0 ) {
        jCartCount.empty();
      } else {
        jCartCount.html( objCart.productLinesCount );
      }
    }
  },
  orderline: {
    bindEvents: function() {
      jQuery( '.js-e-cart-form' )
          .on( 'focus blur', '.js-e-orderline-quantity-input', e4.cart.orderline.toggleFocus )
          .on( 'input', '.js-e-orderline-quantity-input', e4.util.debounce( function( event ) {
            e4.cart.orderline.update( event.target );
          }, e4.settings.debounceDelay.input * 3 ) )
          .on( 'input', '.js-e-orderline-comment-input', e4.util.debounce( function( event ) {
            e4.cart.orderline.saveComment( event.target );
          }, e4.settings.debounceDelay.input * 2 ) )
          .on( 'input', '.js-e-orderline-comment-input', function( event ) {
            e4.cart.orderline.hideCommentHelpText( event.target );
          } )
          .on( 'click', '.js-e-orderline-update-btn', function( event ) {
            event.preventDefault();
            e4.cart.orderline.update( event.target );
          } )
          .on( 'click', '.js-e-orderline-delete-btn', function( event ) {
            event.preventDefault();
            e4.cart.orderline.delete( event.target );
          } )
          .on( 'click', '.js-preview-design-btn', function( event ) {
            const designViewer = document.querySelector( 'designer-viewer' );
            const data = e4.cart.cartData;
            const orderLine = event.target.closest( '.js-e-orderline' );
            console.log( 'orderLine', orderLine.id );
            const designerData = data.cart.designProductorderLines.find( ol => ol[0].id === orderLine.id )[0];
            console.log( designerData );
            designViewer.setAttribute( 'designs', JSON.stringify( {
              title: designerData.productDesignerData.title,
              views: designerData.productDesignerData.views.map( v => v.image ),
            } ) );
            designViewer.setAttribute( 'show', true );

          } );
    },
    update: function( domNode ) {
      var jOrderline = jQuery( domNode ).closest( '.js-e-orderline' ),
          intOrderlineQuantity = parseInt( jOrderline.find( '.js-e-orderline-quantity-input' ).val() );
      if ( intOrderlineQuantity !== 0 ) {
        var jForm = jOrderline.closest( '.js-e-cart-form' ),
            jCart = jForm.closest( '.js-e-cart' ),
            intOrderlineQuantityOriginal = parseInt( jOrderline.data( 'product-quantity' ) );
        if ( intOrderlineQuantity > intOrderlineQuantityOriginal ) {
          jCart.trigger( e4.cart.event.orderlineincrease );
        } else if ( intOrderlineQuantity < intOrderlineQuantityOriginal ) {
          jCart.trigger( e4.cart.event.orderlinedecrease );
        }
        jForm.find( '.js-e-cart-form-cartcmd' ).val( 'updateorderlines' );
        e4.cart.ajax( {
          data: jForm.serialize(),
        }, function( jsonData ) {
          e4.cart.updateContent( jsonData );
          e4.cart.orderline.setFocus( jOrderline.attr( 'id' ) );

        } );
      }
    },
    delete: function( domNode ) {
      var jCart = jQuery( '.js-e-cart' ),
          jOrderline = jQuery( domNode ).closest( '.js-e-orderline' ),
          jOrderLines = jCart.find( '.js-e-orderline' ),
          objOrderlineData = jOrderline.data(),
          jRelatedInputs = jOrderline.find( '.js-identity-orderline-related-id' ),
          jDesignerInputs = jOrderline.find( '.js-identity-orderline-designer-id' ),
          jVariantRelatedInputsCount = 0,
          updateXhr = null;

      const orderContext = jCart.data( 'context' );

      let url = e4.settings.ecom.cart.url;

      if ( orderContext ) {
        url = `${ e4.settings.ecom.cart.url }?OrderContext=${ orderContext }`;
      }

      jOrderLines.not( `[id="${ jOrderline.attr( 'id' ) }"]` ).each( function( index, domOrderLine ) {
        var jVariantRelatedInputs = jQuery( domOrderLine ).find( `.js-identity-orderline-related-id[data-product-id="${ objOrderlineData.productId }"]` );
        if ( jVariantRelatedInputs.length > 0 ) {
          jVariantRelatedInputsCount++;
        }
      } );

      if ( jDesignerInputs.length > 0 ) {
        var updateObj = {
          Redirect: false,
          CartCmd: 'updateorderlines',
        };
        updateObj[`QuantityOrderLine${ jOrderline.attr( 'id' ) }}`] = 0;
        jDesignerInputs.each( function( index, domDesignerInput ) {
          updateObj[`QuantityOrderLine${ domDesignerInput.value }`] = 0;
        } );

        updateXhr = jQuery.ajax( {
          url: url,
          method: 'POST',
          dataType: 'json',
          cache: false,
          data: updateObj,
        } );
      }

      if ( jRelatedInputs.length > 0 && jVariantRelatedInputsCount === 0 ) {
        var updateObj = {
          Redirect: false,
          CartCmd: 'updateorderlines',
        };
        jRelatedInputs.each( function( index, domRelatedInput ) {
          updateObj[`QuantityOrderLine${ domRelatedInput.value }`] = 0;
        } );

        updateXhr = jQuery.ajax( {
          url: url,
          method: 'POST',
          dataType: 'json',
          cache: false,
          data: updateObj,
        } );
      }

      if ( updateXhr !== null ) {
        updateXhr.done( function() {
          deleteMainOrderline( jOrderline, jCart );
        } );
      } else {
        deleteMainOrderline( jOrderline, jCart );
      }

      function deleteMainOrderline( jOrderline, jCart ) {
        jCart.trigger( e4.cart.event.orderlinedelete );

        e4.cart.ajax( {
          data: {
            key: jOrderline.attr( 'id' ),
            CartCmd: 'delorderline',
            Redirect: false,
          },
        }, function( jsonData ) {

          if ( jOrderline.closest( '.js-e-cart-msg-content' ).length > 0 ) {
            jOrderline.slideUp( 'fast', function() {
              e4.cart.msg.hide();
              e4.cart.updateQuantityInfo();
            } );
          } else {
            e4.cart.updateContent( jsonData );
          }
          jCart.trigger( e4.cart.event.orderlinedeleted, {
            currencyCode: jsonData.cart.currencyCode,
            name: objOrderlineData.productName,
            number: objOrderlineData.productNumber,
            price: objOrderlineData.productPrice,
            quantity: objOrderlineData.productQuantity,
            product: {
              brandCode: objOrderlineData.brandCode,
              brandName: objOrderlineData.brandName,
              variant: objOrderlineData.colorVariantText,
            },
          } );
        } );
      }
    },
    saveComment: function( domInput ) {
      e4.cart.ajax( {
        data: [
          domInput.name,
          domInput.value,
        ].join( '=' ),
        beforeSend: jQuery.noop,
      }, function() {
        e4.cart.orderline.showCommentHelpText( domInput );
      } );
    },
    showCommentHelpText: function( domInput ) {
      jQuery( domInput ).closest( '.form-group' ).find( '.js-e-orderline-comment-help-text' ).prop( 'hidden', false );
    },
    hideCommentHelpText: function( domInput ) {
      jQuery( domInput ).closest( '.form-group' ).find( '.js-e-orderline-comment-help-text' ).prop( 'hidden', true );
    },
    setFocus: function( strId ) {
      if ( strId !== '' ) {
        var jOrderline = jQuery( '.js-e-orderline' ).filter( '#' + strId );
        if ( jOrderline.length === 1 ) {
          jOrderline.find( '.js-e-orderline-quantity-input' ).focus();
        }
      }
    },
    getIdByProduct: function( objProduct ) {
      var strReturnValue = '',
          jOrderline = jQuery( '.js-e-orderline' )
              .filter( '[data-product-id="' + objProduct.id + '"][data-product-variant-id="' + objProduct.variantId + '"]' );
      if ( jOrderline.length === 1 ) {
        strReturnValue = jOrderline.attr( 'id' );
      }
      return strReturnValue;
    },
    toggleFocus: function( event ) {
      var jOrderline = jQuery( event.target ).closest( '.js-e-orderline' );
      if ( event.type === 'focusin' ) {
        jQuery( event.target ).select();
        jOrderline.addClass( 'has-focus' );
      } else {
        jOrderline.removeClass( 'has-focus' );
      }
    },
  },
  msg: {
    timeout: null,
    init: function() {
      if ( jQuery( '#js-e-cart-msg' ).length === 1 ) {
        e4.cart.msg.bindEvents();
      }
    },
    bindEvents: function() {
      var jBody = jQuery( 'body' );
      jQuery( '#js-e-cart-msg' ).on( 'show.bs.modal', function() {
        jBody.addClass( 'modal-open-no-adjustment' );
      } ).on( 'hidden.bs.modal', function() {
        jBody.removeClass( 'modal-open-no-adjustment' );
      } ).on( 'click', function( event ) {
        if ( jQuery( event.target ).is( '#js-e-cart-msg' ) === true ) {
          e4.cart.msg.hide();
        }
      } ).on( 'click', '.js-e-orderline-delete-btn', function( event ) {
        event.preventDefault();
        e4.cart.orderline.delete( event.target );
      } ).find( '.modal-dialog' ).on( 'mouseenter', e4.cart.msg.clearTimeout ).on( 'mouseleave', e4.cart.msg.setTimeout );
      jQuery( document ).on( e4.cart.event.productadded, function( event, jsonData ) {
        e4.cart.msg.show( jsonData );
      } );
      document.addEventListener( 'identity:design:added', ( event ) => {
        const productLineQuantity = event.detail.cart.productQuantity;
        if ( productLineQuantity > 0 ) {
          jQuery( '.js-e-design-cart-quantity' ).text( productLineQuantity );
          jQuery( '.js-e-design-cart' ).removeClass( 'd-none' );
        }

      } );
      jQuery( document ).on( e4.cart.event.productadded, function( event, jsonData ) {
        e4.cart.msg.show( jsonData );
      } );
    },
    show: function( jsonData ) {
      var jCartMsg = jQuery( '#js-e-cart-msg' );
      jCartMsg.find( '.js-e-cart-msg-content' ).html( jsonData.cart.lastAddedHtml );
      e4.cart.msg.clearTimeout();
      e4.cart.msg.setPosition();
      jCartMsg.modal( 'show' );
      e4.cart.msg.setTimeout();
    },
    hide: function() {
      e4.cart.msg.clearTimeout();
      var jCartMsg = jQuery( '#js-e-cart-msg' );
      jCartMsg.modal( 'hide' );
    },
    setPosition: function( objPosition ) {
      var jCartMsgDialog = jQuery( '#js-e-cart-msg' ).find( '.modal-dialog' ),
          jHeader = jQuery( '.js-e-header' ),
          jNavItemCart = jHeader.find( '.js-e-nav' ).find( '.js-e-nav-item-cart' ).filter( ':visible' ).first(),
          objCartMsgPosition = objPosition || {},
          objCartMsgReferencePosition = {};
      if ( jCartMsgDialog.length === 1 ) {
        if ( jQuery.isEmptyObject( objCartMsgPosition ) === true ) {
          if ( jNavItemCart.length === 1 ) {
            objCartMsgReferencePosition = jNavItemCart.get( 0 ).getBoundingClientRect();
            objCartMsgPosition = {
              top: jHeader.hasClass( 'is-hidden' ) === true ? '' : Math.floor( objCartMsgReferencePosition.bottom ),
              right: Math.floor( jQuery( window ).width() - objCartMsgReferencePosition.right ),
              left: '',
              maxWidth: '',
            };
          } else {
            objCartMsgPosition = {
              top: 0,
              right: 0,
              left: 0,
              maxWidth: '100%',
            };
          }
        }
      }
      jCartMsgDialog.css( objCartMsgPosition );
    },
    setTimeout: function() {
      e4.cart.msg.clearTimeout();
      e4.cart.msg.timeout = setTimeout( e4.cart.msg.hide, e4.settings.ecom.cart.msgHideDelay );
    },
    clearTimeout: function() {
      if ( e4.cart.msg.timeout ) {
        e4.cart.msg.timeout = clearTimeout( e4.cart.msg.timeout );
      }
    },
  },
};

